import {
    getZoneByParent
  } from '../../assets/xhr';
  
  
  // 通用的异步数据获取函数
  function fetchData(type, params = {}) {
    return new Promise((resolve, reject) => {
        const fetchMap = {
            country: getZoneByParent,
            province: getZoneByParent,
            city: getZoneByParent,
            district: getZoneByParent
        };

        fetchMap[type](params, (result) => {
            resolve(result);
        }, (error) => {
            reject(error);
        });
    });
  }
  
  // 获取国家列表
  export function getCountries(params,callback) {
  

  
  
    fetchData('country',params)
        .then(result => {
            callback(result);
        })
        .catch(error => {
            console.error('获取国家列表失败', error);
        });
  }
  
  // 获取省份列表
  export function getProvinces(countryId, callback) {
  
    fetchData('province', countryId )
        .then(result => {
            // data.province = { ...result, countryId };
            // callbacks.province.forEach(cb => cb(result));
            // callbacks.province = [];
            callback(result);
        })
        .catch(error => {
            console.error('获取省份列表失败', error);
        });
  }
  
  // 获取城市列表
  export function getCities(provinceId, callback) {
  
    fetchData('city', provinceId )
        .then(result => {
            // data.city = { ...result, provinceId };
            // callbacks.city.forEach(cb => cb(result));
            // callbacks.city = [];
            callback(result);
        })
        .catch(error => {
            console.error('获取城市列表失败', error);
        });
  }
  
  // 获取区县列表
  export function getDistricts(cityId, callback) {
  
    fetchData('district', cityId )
        .then(result => {
            callback(result);
        })
        .catch(error => {
            console.error('获取区县列表失败', error);
        });
  }


// WEBPACK FOOTER //
// ./src/component/Address/data.js